import Moment from 'moment-timezone';
import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/**
 * Score based on actual meetings duration versus planned duration
 */
export default new VitalityCriterion({
  titleTr: 'VH_M_DURATION',
  key: 'meetingDuration',
  weight: 1,

  score: ({ meetings, plannings }, range, a, team) => {
    // Duration in seconds per meeting planning
    const durationPerPlanning = {};
    const nPlannings = plannings.length;
    for (let i = 0; i < nPlannings; i++) {
      const { id, stepsData } = plannings[i];
      durationPerPlanning[`${id}`] = stepsData.reduce((duration, step) => {
        return duration + step.duration;
      }, 0);
    }
    // Calculate total absolute gap between planned duration and actual duration
    const filtered = meetings.filter(m => range.start.isBefore(m.date) && range.end.isAfter(m.date));
    const nMeetings = filtered.length;
    // Total gap in seconds between planned duration and actual duration
    let totalGap = 0;
    // Total gap percentage => (gap / plannedDuration) * 100
    let totalGapPercentage = 0
    for (let i = 0; i < nMeetings; i++) {
      const { created, ended, planningId } = filtered[i];
      const plannedDuration = durationPerPlanning[`${planningId}`];
      const mEnd = Moment(ended);
      if (mEnd.isValid() && plannedDuration) {
        const actualDuration = mEnd.diff(created, 's');
        const gap = Math.abs(actualDuration - plannedDuration);
        totalGap += gap;
        totalGapPercentage += (gap * 100 / plannedDuration).sBetweenBoundaries(0, 100);
      }
    }

    const noMeetings = nMeetings === 0;
    if (!noMeetings) {
      totalGap /= nMeetings;
      totalGapPercentage /= nMeetings;
    }
    const score = noMeetings ? 0 : 100 - (totalGapPercentage / nMeetings);
    return {
      score,
      data: {
        value: totalGap,
        noTopsFlops: noMeetings,
        noCategoryHint: noMeetings,
        noMeetings,
      },
    };
  },

  text: ({ value, noMeetings }) => {
    if (noMeetings) {
      return i18n.t('message.VH_M_NO_MEETING');
    }
    const momentGap = Moment.utc(value * 1000);
    let format = 'HH:mm:ss';
    const nHours = Number(momentGap.format('H'));
    if (nHours === 0) {
      format = 'mm:ss';
    }
    const readableGap = momentGap.format(format);
    return i18n.t('message.VH_M_DURATION_TEXT', { gap: readableGap });
  },

});
